import _ from 'helpers/no_conflict_lodash';
import moment from 'moment';

export const sortTasks = (tasks) => {
  const overdue = [];
  const completed = [];
  const notCompleted = [];

  _.each(tasks, (task) => {
    if (task.completedAt != null) {
      completed.push(task);
    } else if (moment(task.dueDate).isBefore(moment())) {
      overdue.push(task);
    } else {
      notCompleted.push(task);
    }
  });
  return notCompleted.reverse().concat(overdue).concat(completed);
};
